import gql from 'graphql-tag'
import { EntityFields, EnumFields } from '..'

export const SupportDocumentTypeFragment = gql`
    fragment SupportDocumentType on settings_support_document_type {
        ${EntityFields}
        ${EnumFields}
    }
`
